module.exports = __webpack_public_path__ + "images/daimler261f375f500e4d585b4df3017cc5c8c9.png";